module.exports = __webpack_public_path__ + "img/copyright_textimg.eef64b7d.png";